"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.index-of.js");

/*
 * 字符串处理的方法
 */
var Strings = {
  /**
   * @function Str[toSubstring] - 截取字符串
   * @param {string} str 开始位置
   * @param {number} [stop=-1] 结束位置，默认所有字符
   * @param {string} [flag=...] 结尾字符
   * @return {string}
   */
  toSubstring: function toSubstring(str) {
    var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

    if (str.length <= stop) {
      return str;
    }

    if (stop < 0) flag = '';
    return "".concat(str.substring(0, stop)).concat(flag);
  },

  /**
   * @function Str[trim] - 去除字符串两边空白
   * @param {string} [str=''] 需要处理的字符串
   * @return {string}
   */
  trim: function trim() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return str.replace(/^\s+|\s+$/g, '');
  },

  /**
   * @function Str[sIscontainC] - 判断字符串里不含有某些字符或字符串
   * @param {string} str 目标字符串
   * @param {string} char 字符
   * @return {boolean} true/false
   */
  sIscontainC: function sIscontainC() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return str.indexOf(_char) !== -1;
  }
};
var _default = Strings;
exports["default"] = _default;